import React from 'react';

/** Section generated from the "LegalPage" block of the Aurm design handoff. */
export default function LegalPage({ V }) {
  return (<>
    <div>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "112px 40px 48px" }}>{" "}
        <p style={{ display: "flex", alignItems: "center", gap: "12px", fontSize: "12px", fontWeight: "600", letterSpacing: ".22em", textTransform: "uppercase", color: "rgba(255,255,255,.72)" }}>
          <span aria-hidden="true" style={{ width: "22px", height: "1px", background: "#DB2349", flex: "none" }}></span>Legal
        </p>{" "}
        <h1 style={{ marginTop: "26px", fontSize: "clamp(44px,6vw,80px)", lineHeight: "1", letterSpacing: "-.04em", fontWeight: "600" }}>{V.legalTitle}</h1>{" "}
        <p style={{ marginTop: "20px", fontSize: "15px", color: "rgba(255,255,255,.6)" }}>{V.legalMeta}</p>{" "}
        <div role="tablist" aria-label="Legal documents" style={{ marginTop: "36px", display: "flex", flexWrap: "wrap", gap: "8px" }}>{" "}
          {(V.legalTabs || []).map((t, $index) => (
            <React.Fragment key={$index}>{" "}
            <a href={t.href} role="tab" aria-selected={t.selected} style={t.style}>{t.label}</a>{" "}
            </React.Fragment>
          ))}{" "}
        </div>{" "}
      </section>{" "}
      <section data-r="pad" style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 40px", display: "flex", flexWrap: "wrap", gap: "56px", alignItems: "flex-start" }}>{" "}
        <nav aria-label="On this page" style={V.tocNav}>{" "}
          <p style={{ padding: "0 14px 12px", fontSize: "12px", fontWeight: "600", letterSpacing: ".2em", textTransform: "uppercase", color: "rgba(255,255,255,.55)" }}>On this page</p>{" "}
          {(V.legalToc || []).map((c, $index) => (
            <React.Fragment key={$index}>{" "}
            <a className="aurm-hh" href={c.anchor} style={{ display: "grid", gridTemplateColumns: "28px 1fr", gap: "6px", padding: "9px 14px", borderRadius: "12px", fontSize: "14px", lineHeight: "1.4", color: "rgba(255,255,255,.75)" }}>
              <span style={{ color: "rgba(255,255,255,.45)", fontVariantNumeric: "tabular-nums" }}>{c.num}</span>{c.title}
            </a>{" "}
            </React.Fragment>
          ))}{" "}
        </nav>{" "}
        <div style={{ flex: "999 1 520px", minWidth: "0", display: "flex", flexDirection: "column", gap: "56px" }}>{" "}
          {V.legalIntro ? (<>
            <p style={{ fontSize: "20px", lineHeight: "1.6", color: "rgba(255,255,255,.86)" }}>{V.legalIntro}</p>
          </>) : null}{" "}
          {V.refundPending ? (<>{" "}
            <div style={{ padding: "40px", borderRadius: "28px", border: "1px solid rgba(255,255,255,.12)", background: "linear-gradient(180deg,rgba(46,30,78,.97),rgba(34,20,60,.97))", display: "flex", flexDirection: "column", gap: "16px" }}>{" "}
              <h2 style={{ fontSize: "26px", letterSpacing: "-.02em", fontWeight: "600" }}>This policy is being finalised</h2>{" "}
              <p style={{ fontSize: "17px", lineHeight: "1.65", color: "rgba(255,255,255,.76)", maxWidth: "56ch" }}>We are dedicated to a transparent and fair process for handling refunds. Until the full policy is published, the team will answer any refund question directly.</p>{" "}
              <a href={V.waGeneral} target="_blank" rel="noopener noreferrer" style={{ alignSelf: "flex-start", marginTop: "8px", display: "inline-flex", alignItems: "center", height: "48px", padding: "0 24px", borderRadius: "999px", background: "linear-gradient(180deg,#e5385c 0%,#DB2349 55%,#c91f43 100%)", fontSize: "15px", fontWeight: "600" }}>Ask on WhatsApp</a>{" "}
            </div>{" "}
          </>) : null}{" "}
          {V.legalLoading ? (<>
            <p style={{ fontSize: "16px", color: "rgba(255,255,255,.6)" }}>Loading the document...</p>
          </>) : null}{" "}
          {(V.legalSections || []).map((sec, $index) => (
            <React.Fragment key={$index}>{" "}
            <div id={sec.id} style={{ scrollMarginTop: "110px", paddingTop: "40px", borderTop: "1px solid rgba(255,255,255,.1)" }}>{" "}
              <h2 style={{ display: "flex", gap: "16px", fontSize: "clamp(22px,2.2vw,28px)", lineHeight: "1.25", letterSpacing: "-.02em", fontWeight: "600" }}>
                <span style={{ color: "#ff8a9c", fontVariantNumeric: "tabular-nums" }}>{sec.num}</span>{sec.title}
              </h2>{" "}
              <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>{" "}
                {(sec.blocks || []).map((bl, $index) => (
                  <React.Fragment key={$index}>{" "}
                  <div style={bl.row}>{" "}
                    <span style={{ fontSize: "15px", color: "rgba(255,255,255,.5)", fontVariantNumeric: "tabular-nums", paddingTop: "2px" }}>{bl.num}</span>{" "}
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", minWidth: "0" }}>{" "}
                      {bl.heading ? (<>
                        <p style={{ fontSize: "17px", fontWeight: "600" }}>{bl.heading}</p>
                      </>) : null}{" "}
                      {bl.text ? (<>
                        <p style={{ fontSize: "16px", lineHeight: "1.75", color: "rgba(255,255,255,.8)" }}>{bl.text}</p>
                      </>) : null}{" "}
                      {bl.hasItems ? (<>{" "}
                        <ul style={{ listStyle: "none", padding: "0", display: "flex", flexDirection: "column", gap: "10px" }}>{" "}
                          {(bl.items || []).map((it, $index) => (
                            <React.Fragment key={$index}>{" "}
                            <li style={it.style}>
                              <span style={{ color: "rgba(255,255,255,.5)" }}>{it.label}</span>
                              <span>{it.text}</span>
                            </li>{" "}
                            </React.Fragment>
                          ))}{" "}
                        </ul>{" "}
                      </>) : null}{" "}
                    </div>{" "}
                  </div>{" "}
                  </React.Fragment>
                ))}{" "}
              </div>{" "}
            </div>{" "}
            </React.Fragment>
          ))}{" "}
        </div>{" "}
      </section>
    </div>
  </>);
}
